import { createSlice } from '@reduxjs/toolkit';
import { createSelector } from 'reselect';
import axios from 'axios';
import { apiCallBegan } from './api';
import _ from 'lodash';
import { format, parseISO } from 'date-fns';

import config from '../config/config';

// const apiMealEndpoint = '/api/meal/';
const apiToken = process.env.REACT_APP_API_TOKEN;

const slice = createSlice({
  name: 'meal',
  initialState: {
    list: []
  },
  reducers: {
    // { id: 1, name: 'Первое', price: 200, mealTypeId: 1,isCombo:2},

    // { title: 'Цена', field: 'priceStaff' },
    // { title: 'Цена', field: 'priceHelpers' },
    // { title: 'Цена', field: 'priceKids_5' },
    // { title: 'Цена', field: 'priceKids_12' },

    mealReceived: (meal, action) => {
      // meal.list = action.payload.data;
      // console.log('action.payload.data',action.payload.data[0]);
      // console.log('action.payload.data;', action.payload.data);
      meal.list = [];
      action.payload.data.forEach(m => {
        meal.list.unshift({
          id: m.id,
          name: m.name,
          price: m.price,
          priceStaff: m.prices && m.prices.priceStaff ? m.prices.priceStaff : 0,
          priceHelpers:
            m.prices && m.prices.priceHelpers ? m.prices.priceHelpers : m.price,
          priceKids5:
            m.prices && m.prices.priceKids5 ? m.prices.priceKids5 : m.price,
          priceKids12:
            m.prices && m.prices.priceKids12 ? m.prices.priceKids12 : m.price,
          points: m.prices && 'points' in m.prices ? m.prices.points : 1,
          mealTypeId: m.mealtype_id,
          isCombo: m.is_combo ? 1 : 2,
          comboMeals:
            m.combo_meals[0].mealcombo_id !== null ? m.combo_meals : []
        });
      });
    },

    mealAdded: (meal, action) => {
      // console.log('mealAdded',meal, action);
      meal.list.push({
        ...action.payload.params.meal,
        id: action.payload.data.id
      });
    },

    mealComboAdded: (meal, action) => {
      // console.log('mealComboAdded',meal, action);
      const { mealId, comboId } = action.payload.params;
      const index = meal.list.findIndex(m => m.id === comboId);
      meal.list[index].comboMeals.unshift({
        meal_id: mealId,
        mealcombo_id: action.payload.data.mealcombo_id
      });
    },

    mealComboDeleted: (meal, action) => {
      // console.log('mealComboDeleted',meal, action);
      const { mealComboId, comboId } = action.payload.params;
      const index = meal.list.findIndex(m => m.id === comboId);
      meal.list[index].comboMeals = meal.list[index].comboMeals.filter(
        n => n.mealcombo_id !== mealComboId
      );
    },

    mealChanged: (meal, action) => {
      // console.log('mealAdded',meal, action);
      const { meal: newMeal } = action.payload.params;
      const index = meal.list.findIndex(m => m.id === newMeal.id);
      meal.list[index] = newMeal;

      // meal.list.push({
      //   ...action.payload.params.meal,
      //   id: action.payload.data.id
      // });
    },

    mealDeleted: (meal, action) => {
      meal.list = meal.list.filter(n => n.id !== action.payload.params.mealId);
    }
  }
});

const {
  mealReceived,
  mealAdded,
  mealDeleted,
  mealChanged,
  mealComboAdded,
  mealComboDeleted
} = slice.actions;
export default slice.reducer;

// Action Creators

export const loadMeal = () => async (dispatch, getState) => {
  return await dispatch(
    apiCallBegan({
      url: `/api/meal/?secret_key=${apiToken}`,
      onSuccess: mealReceived.type,
      actionName: 'loadMeal'
    })
  );
};

export const addMeal = meal =>
  apiCallBegan({
    url: `/api/meal/?secret_key=${apiToken}`,
    method: 'post',
    data: { meal },
    onSuccess: mealAdded.type,
    actionName: 'addMeal',
    params: { meal }
  });

export const changeMeal = meal =>
  apiCallBegan({
    url: `/api/meal/?secret_key=${apiToken}`,
    method: 'put',
    data: { meal },
    onSuccess: mealChanged.type,
    actionName: 'changeMeal',
    params: { meal }
  });

export const delMeal = mealId =>
  apiCallBegan({
    url: `/api/meal/${mealId}/?secret_key=${apiToken}`,
    method: 'delete',
    onSuccess: mealDeleted.type,
    actionName: 'delMeal',
    params: { mealId }
  });

export const addMealCombo = ({ mealId, comboId }) =>
  apiCallBegan({
    url: `/api/meal/combo/?secret_key=${apiToken}`,
    method: 'post',
    data: { mealId, comboId },
    onSuccess: mealComboAdded.type,
    actionName: 'addMealCombo',
    params: { mealId, comboId }
  });

export const deleteMealCombo = ({ mealComboId, comboId }) =>
  apiCallBegan({
    url: `/api/meal/combo/${mealComboId}/?secret_key=${apiToken}`,
    method: 'delete',
    onSuccess: mealComboDeleted.type,
    actionName: 'deleteMealCombo',
    params: { mealComboId, comboId }
  });

// Selectors

export const getMealSelector = createSelector(
  state => state.entities.meal.list,
  meal => meal
);

export const getNotComboSelector = createSelector(
  state => state.entities.meal.list,
  meal => meal.filter(m => parseInt(m.isCombo) !== 1)
);

// Helpers methods
